// TODO: re-evaluate

import { Geolocation } from '../provider/GeolocationProvider';
import { VehicleCenter } from '../provider/Typo3Provider/types';
import { Maybe } from '../types';

export const getUserLocationCenter = (
  markers: VehicleCenter[],
  geolocation: Maybe<Geolocation>,
  userCountry: string
): Maybe<VehicleCenter> => {
  const possibleIndices = markers.reduce((indices: number[], marker, i) => {
    if (marker.countryCode === userCountry) {
      indices.push(i);
    }
    return indices;
  }, []);

  if (possibleIndices.length >= 0) {
    const possibleMarkers = possibleIndices.map(item => markers[item]);

    const supportsGeolocation = geolocation && geolocation.supported;

    if (possibleMarkers.length > 1 && geolocation && supportsGeolocation) {
      const { lat, lon } = geolocation;
      const distancedMarker = possibleMarkers.map(marker => ({
        marker,
        distance:
          // Math.sqrt is missing because it has no effect on the final sorting
          // and therefore is absolutly unnecessary computational overhead.
          Math.pow(parseFloat(marker.latitude) - lat, 2) +
          Math.pow(parseFloat(marker.longitude) - lon, 2)
      }));
      distancedMarker.sort((a, b) => a.distance - b.distance);

      return distancedMarker[0].marker;
    }
    if (possibleMarkers.length > 1) {
      return possibleMarkers.filter(
        ({ isMainLocationInCountry }) => isMainLocationInCountry
      )[0];
    }
    return possibleMarkers[0];
  }

  return null;
};
